export class StorageArticle {
  id: number;
  name: string;
  serial: boolean;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class StorageArticleWeb {
  articleId: number;
  name: string;
  serial: boolean;
  quantity: number;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/StorageArticle.ts